<template>
  <div class="column-pagination d-flex align-items-center">
    <div>
      <span>Page {{ fieldPagination.current_page }} of {{ fieldPagination.total_pages }} |
        Columns {{ startColumn }}-{{ endColumn }} of {{ fieldPagination.total_count }}</span>
    </div>
    <div class="d-flex mx-2" style="gap: 10px;">
      <!-- First Page Button -->
      <v-icon size="26" dense :color="fieldPagination.current_page > 1 ? 'primary' : 'grey'"
        :style="{ cursor: fieldPagination.current_page > 1 ? 'pointer' : 'default' }"
        @click="goToPage(1)">
        mdi-page-first
      </v-icon>

      <!-- Previous Button -->
      <v-icon size="26" dense :color="fieldPagination.current_page > 1 ? 'primary' : 'grey'"
        :style="{ cursor: fieldPagination.current_page > 1 ? 'pointer' : 'default' }"
        @click="goToPage(fieldPagination.current_page - 1)">
        mdi-chevron-left
      </v-icon>

      <!-- Next Button -->
      <v-icon size="26" dense :color="fieldPagination.current_page < fieldPagination.total_pages ? 'primary' : 'grey'"
        :style="{ cursor: fieldPagination.current_page < fieldPagination.total_pages ? 'pointer' : 'default' }"
        @click="goToPage(fieldPagination.current_page + 1)">
        mdi-chevron-right
      </v-icon>

      <!-- Last Page Button -->
      <v-icon size="26" dense :color="fieldPagination.current_page < fieldPagination.total_pages ? 'primary' : 'grey'"
        :style="{ cursor: fieldPagination.current_page < fieldPagination.total_pages ? 'pointer' : 'default' }"
        @click="goToPage(fieldPagination.total_pages)">
        mdi-page-last
      </v-icon>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';


export default {
  components: {

  },
  props: {

  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters({
      fieldPagination: 'reportTemplates/fieldPagination',
      selectedColumns: 'reportTemplates/selectedColumns',
      hasUnsavedChanges: "reportTemplates/hasUnsavedChanges",
    }),
    startColumn() {
      return (this.fieldPagination.current_page - 1) * this.fieldPagination.per_page + 1;
    },
    endColumn() {
      return Math.min(this.startColumn + this.fieldPagination.per_page - 1, this.fieldPagination.total_count);
    },
  },
  methods: {
    ...mapActions({
      getReportFields: 'reportTemplates/getReportFields',
    }),
    ...mapMutations({
      setPagination: 'reportTemplates/setFieldPagination',
    }),
    goToPage(page) {
      if (page < 1 || page > this.fieldPagination.total_pages) return;

      if (this.hasUnsavedChanges) {
        this.setPagination({
          current_page: page,
          per_page: this.fieldPagination.per_page,
          total_count: this.selectedColumns.length,
          total_pages: Math.ceil(this.selectedColumns.length / this.fieldPagination.per_page),
        });
      } else {
        this.setPagination({
          current_page: page,
          per_page: this.fieldPagination.per_page,
        });

        this.getReportFields(this.$route.params.id);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.column-pagination {
  color: #3F3F3F;
  font-size: 14px;
}
</style>